import $ from 'jquery';
import datepicker from 'js-datepicker';

export default function dosingCalc() {
  const customDays = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
  const dpDefaultOptions = {
    alwaysShow: true,
    showAllDates: true,
    customDays,
  };

  const $injectionLastDateElem = $('.js-injection-last-date');
  const $injectionLastDateDay2Elem = $('.js-injection-last-date-day-2');
  const $injectionNextDateElem = $('.js-injection-next-date');
  const $injectionWindowStartDateElem = $('.js-injection-window-start-date');
  const $injectionWindowEndDateElem = $('.js-injection-window-end-date');
  const $nextInjectionInfo = $('.js-next-injection-info');
  const $injectionResults = $('.js-injection-results');

  const $inducerInitDateElem = $('.js-inducer-init-date');
  const $supplementalDoseDateElem = $('.js-supplemental-dose-date');
  const $supplementalDoseDate2Elem = $('.js-supplemental-dose-date-2');
  const $supplementalDoseNextDateElem = $('.js-supplemental-dose-next-date');
  const $supplementalDoseNextDate1Elem = $('.js-supplemental-dose-next-date-1');
  const $supplementalDoseNextDate2Elem = $('.js-supplemental-dose-next-date-2');
  const $supplementalDoseWindowStartDateElem = $('.js-supplemental-dose-window-start-date');
  const $supplementalDoseWindowEndDateElem = $('.js-supplemental-dose-window-end-date');
  const $supplementalDoseInfo = $('.js-supplemental-dose-info');
  const $inducerResults = $('.js-inducer-results');

  const $inducerSelect = $('.js-inducer-select');

  const lastInjectionDatePicker = datepicker($('.js-last-injection-dp')[0], {
    ...dpDefaultOptions,
    onSelect: (instance, date) => {
      if ( !date ) {
        $nextInjectionInfo.addClass('is-hidden');

        return;
      }

      if ( !$('.js-dose-type-radio-btn:checked').length ) {
        $('.js-dose-type-radio-btn').first().prop('checked', true).trigger('change');
      }

      retriggerSelect2($inducerSelect);

      $nextInjectionInfo.removeClass('is-hidden');
      $injectionResults.removeClass('is-hidden');
      $('.js-missing-injection-date-error').addClass('is-hidden');

      const injectionLastDate = new Date(date);
      $injectionLastDateElem.html(formatDateWithSuffix(injectionLastDate));

      const injectionLastDateDay2 = new Date(injectionLastDate);
      injectionLastDateDay2.setDate(injectionLastDateDay2.getDate() + 1);
      $injectionLastDateDay2Elem.html(formatDateWithSuffix(injectionLastDateDay2));

      // Date after 26 weeks
      const nextInjectionDate = new Date(date);
      nextInjectionDate.setDate(nextInjectionDate.getDate() + 182); // 26 weeks

      $injectionNextDateElem.html(formatDateWithSuffix(nextInjectionDate));

      // 2 week window
      const windowStart = new Date(nextInjectionDate);
      windowStart.setDate(windowStart.getDate() - 14);

      const windowEnd = new Date(nextInjectionDate);
      windowEnd.setDate(windowEnd.getDate() + 14);

      $injectionWindowStartDateElem.text(windowStart.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }));
      $injectionWindowEndDateElem.text(windowEnd.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }));

      nextInjectionMonth1DatePicker.setDate();
      nextInjectionMonth2DatePicker.setDate();
      nextInjectionMonth1DatePicker.setDate(windowStart, true);
      nextInjectionMonth2DatePicker.setDate(windowEnd, true);

      if (nextInjectionMonth1DatePicker.currentMonth === nextInjectionMonth2DatePicker.currentMonth) {
        nextInjectionMonth1DatePicker.calendarContainer.classList.add('is-hidden');
      } else {
        nextInjectionMonth1DatePicker.calendarContainer.classList.remove('is-hidden');
      }

      updateNextDate(nextInjectionMonth1DatePicker, nextInjectionMonth2DatePicker);

      pushEventToGTM('Injection_Date_Select', {
        value: formatDate(injectionLastDate),
      });
    },
  });

  const nextInjectionMonth1DatePicker = datepicker($('.js-next-injection-m1-dp')[0], {
    id: 1,
    ...dpDefaultOptions,
  });

  const nextInjectionMonth2DatePicker = datepicker($('.js-next-injection-m2-dp')[0], {
    id: 1,
    ...dpDefaultOptions,
  });

  const inducerInitDatePicker = datepicker($('.js-inducer-init-dp')[0], {
    ...dpDefaultOptions,
    onSelect: (instance, date) => {
      if ( !date ) {
        $supplementalDoseInfo.addClass('is-hidden');

        return;
      }

      const inducerInitDate = new Date(date);
      $inducerInitDateElem.html(formatDateWithSuffix(inducerInitDate));

      const lastInjectionDate = lastInjectionDatePicker && lastInjectionDatePicker.dateSelected;

      pushEventToGTM('Inducer_Date_Select', {
        value: formatDate(inducerInitDate),
      });

      if (lastInjectionDate) {
        const MS = 86400000;
        const dInj = new Date(lastInjectionDate);
        const dInd  = new Date(inducerInitDate);
        const diffDays = (dInd.setHours(0,0,0,0) - dInj.setHours(0,0,0,0)) / MS;

        const isStrongInducer = $inducerSelect.find(':selected').data('inducer').toLowerCase() === 'strong';
        const isInitiationDoseType = $('.js-dose-type-radio-btn:checked').val().toLowerCase() === 'initiation';

        if (inducerInitDate < lastInjectionDate && isInitiationDoseType) {
          $supplementalDoseInfo.addClass('is-hidden');
          $inducerResults.addClass('is-hidden');
          $('.js-inducer-within-2d-after-injection').addClass('is-hidden');
          $('.js-radio-buttons-wrap').addClass('is-hidden');
          $('.js-next-supplemental-dose-content').addClass('is-hidden');
          $('.js-inducer-before-injection-info').removeClass('is-hidden');
          $injectionResults.addClass('is-hidden');
          resetRadioButtons();

          return;
        } else if ( diffDays >= 0 && diffDays <= 2 && isStrongInducer && isInitiationDoseType) {
          $supplementalDoseInfo.addClass('is-hidden');
          $inducerResults.addClass('is-hidden');
          $('.js-inducer-before-injection-info').addClass('is-hidden');
          $('.js-radio-buttons-wrap').addClass('is-hidden');
          $('.js-next-supplemental-dose-content').addClass('is-hidden');
          $('.js-inducer-within-2d-after-injection').removeClass('is-hidden');
          $injectionResults.removeClass('is-hidden');
          resetRadioButtons();

          return;
        }
      } else {
        $('.js-missing-injection-date-error').removeClass('is-hidden');

        return;
      }

      $injectionResults.removeClass('is-hidden');
      $supplementalDoseInfo.removeClass('is-hidden');
      $inducerResults.removeClass('is-hidden');
      $('.js-radio-buttons-wrap').removeClass('is-hidden');
      $(
        '.js-inducer-before-injection-info, .js-inducer-within-2d-after-injection, .js-missing-injection-date-error'
      ).addClass('is-hidden');

      const isStrongInducer = $inducerSelect.find(':selected').data('inducer').toLowerCase() === 'strong';

      if (isStrongInducer) {
        const plusOneDay = addDays(inducerInitDate, 1);

        $supplementalDoseDateElem.html(formatDateRangeWithSuffix(inducerInitDate, plusOneDay));
        $supplementalDoseDate2Elem.html(formatDateWithSuffix(plusOneDay));
        supplementalDoseDatePicker.calendar.classList.add('highlight-next-day-after-active');
        nextSupplementalMonth1DatePicker.calendar.classList.add('highlight-next-day-after-active');
        nextSupplementalMonth2DatePicker.calendar.classList.add('highlight-next-day-after-active');

      } else {
        $supplementalDoseDateElem.html(formatDateWithSuffix(inducerInitDate));
        supplementalDoseDatePicker.calendar.classList.remove('highlight-next-day-after-active');
        nextSupplementalMonth1DatePicker.calendar.classList.remove('highlight-next-day-after-active');
        nextSupplementalMonth2DatePicker.calendar.classList.remove('highlight-next-day-after-active');
      }

      supplementalDoseDatePicker.setDate(inducerInitDate, true);

      // Date after 26 weeks
      const nextSupplementalDoseDate = new Date(date);
      nextSupplementalDoseDate.setDate(nextSupplementalDoseDate.getDate() + 182); // 26 weeks

      if (isStrongInducer) {
        const plusOneDay = addDays(nextSupplementalDoseDate, 1);

        $supplementalDoseNextDate1Elem.html(formatDateWithSuffix(nextSupplementalDoseDate));
        $supplementalDoseNextDate2Elem.html(formatDateWithSuffix(plusOneDay));
        $supplementalDoseNextDateElem.html(formatDateRangeWithSuffix(nextSupplementalDoseDate, plusOneDay));
      } else {
        $supplementalDoseNextDateElem.html(formatDateWithSuffix(nextSupplementalDoseDate));
      }

      // 2 week window
      const windowStart = new Date(nextSupplementalDoseDate);
      windowStart.setDate(windowStart.getDate() - 14);

      const windowEnd = new Date(nextSupplementalDoseDate);
      windowEnd.setDate(windowEnd.getDate() + 14);

      $supplementalDoseWindowStartDateElem.text(windowStart.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }));
      $supplementalDoseWindowEndDateElem.text(windowEnd.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }));

      nextSupplementalMonth1DatePicker.setDate();
      nextSupplementalMonth2DatePicker.setDate();
      nextSupplementalMonth1DatePicker.setDate(windowStart, true);
      nextSupplementalMonth2DatePicker.setDate(windowEnd, true);

      if (nextSupplementalMonth1DatePicker.currentMonth === nextSupplementalMonth2DatePicker.currentMonth) {
        nextSupplementalMonth1DatePicker.calendarContainer.classList.add('is-hidden');
      } else {
        nextSupplementalMonth1DatePicker.calendarContainer.classList.remove('is-hidden');
      }

      updateNextDate(nextSupplementalMonth1DatePicker, nextSupplementalMonth2DatePicker);
    },
  });

  const supplementalDoseDatePicker = datepicker($('.js-supplemental-dosing-dp')[0], {
    ...dpDefaultOptions,
  });

  const nextSupplementalMonth1DatePicker = datepicker($('.js-next-supplemental-m1-dp')[0], {
    id: 2,
    ...dpDefaultOptions,
  });

  const nextSupplementalMonth2DatePicker = datepicker($('.js-next-supplemental-m2-dp')[0], {
    id: 2,
    ...dpDefaultOptions,
  });

  // Disable datepickers
  nextInjectionMonth1DatePicker.disabled = true;
  nextInjectionMonth2DatePicker.disabled = true;
  supplementalDoseDatePicker.disabled = true;
  nextSupplementalMonth1DatePicker.disabled = true;
  nextSupplementalMonth2DatePicker.disabled = true;

  // Inducer select
  $inducerSelect.on('select2:select', function (e, params) {
    const isUserAction =
      (e && e.originalEvent) ||
      (e && e.params && e.params.originalEvent) ||
      (typeof e.isTrigger !== 'number' ? true : e.isTrigger === 0);

    const isSilent = (params && params.silent) || (e && e.params && e.params.silent);

    const data =
      (e && e.params && e.params.data) ||
      (params && params.data) ||
      ($inducerSelect.select2('data')[0]) ||
      null;

    if (isUserAction && !isSilent) {
      pushEventToGTM('Dose_Select', {
        value: data.text || data.id,
      });
    }

    if (!data) return;

    const inducerType = data.element.dataset.inducer;
    const inducerName = data.id || data.text;
    const lastInjectionDate = lastInjectionDatePicker && lastInjectionDatePicker.dateSelected;

    if ( !lastInjectionDate ) {
      $('.js-missing-injection-date-error').removeClass('is-hidden');

      return;
    }

    if ( !inducerType ) {
      $('.js-inducer-content, .js-inducer-results').addClass('is-hidden');

      return;
    }

    // Reset content
    inducerInitDatePicker.setDate(null, true);
    supplementalDoseDatePicker.setDate(null, true);
    $supplementalDoseInfo.addClass('is-hidden');
    $inducerResults.addClass('is-hidden');
    $inducerInitDateElem.html('');
    $supplementalDoseDateElem.html('');
    $(
      '.js-inducer-before-injection-info, .js-inducer-within-2d-after-injection, .js-missing-injection-date-error, .js-radio-buttons-wrap'
    ).addClass('is-hidden');
    resetRadioButtons();
    // END Reset content

    $('.js-inducer-content').removeClass('is-hidden');
    $('.js-inducer-name').text(inducerName);

    // Strong inducer data
    if ( inducerType === 'strong' ) {
      $('.js-strong-inducer-content').removeClass('is-hidden');
      $('.js-moderate-inducer-content').addClass('is-hidden');
    } else {
      $('.js-strong-inducer-content').addClass('is-hidden');
      $('.js-moderate-inducer-content').removeClass('is-hidden');
    }
  });

  // Dose type radio buttons
  $('.js-dose-type-radio-btn').on('change', function () {
    const value = $(this).val().toLowerCase();
    const gtmEvent = $(this).data('gtm-event');

    retriggerSelect2($inducerSelect);

    $('.js-dose-type-results').addClass('is-hidden');
    $(`.js-dose-type-results[data-dose-type="${value}"]`).removeClass('is-hidden');

    pushEventToGTM(gtmEvent, {
      value,
    });
  });

  // Inducer radio buttons
  $('.js-inducer-radio-btn').on('change', function (e) {
    const value = $(this).val().toLowerCase();
    const isStrongInducer = $inducerSelect.find(':selected').data('inducer').toLowerCase() === 'strong';
    const isModerateInducer = $inducerSelect.find(':selected').data('inducer').toLowerCase() === 'moderate';
    const gtmEvent = $(this).data('gtm-event');

    if ( value !== 'yes' || value === 'yes' && !inducerInitDatePicker.dateSelected ) {
      $('.js-next-supplemental-dose-content').addClass('is-hidden');
    } else {
      $('.js-next-supplemental-dose-content').removeClass('is-hidden');
    }

    if ( isStrongInducer && value === 'yes' ) {
      $('.js-strong-inducer-continued-content').removeClass('is-hidden');
    } else {
      $('.js-strong-inducer-continued-content').addClass('is-hidden');
    }

    if ( isModerateInducer && value === 'yes' ) {
      $('.js-moderate-inducer-continued-content').removeClass('is-hidden');
    } else {
      $('.js-moderate-inducer-continued-content').addClass('is-hidden');
    }

    if (e.originalEvent || !e.isTrigger) {
      pushEventToGTM(gtmEvent, {
        value,
      });
    }
  });

  const updateNextDate = (datepicker1, datepicker2) => {
    const datepicker1ActiveDate = datepicker1.calendar.querySelector('.qs-active');
    const datepicker2ActiveDate = datepicker2.calendar.querySelector('.qs-active');

    const moveDateBySteps = (currentElem, steps) => {
      let targetElem = currentElem;

      for (let i = 0; i < Math.abs(steps) && targetElem; i++) {
        targetElem = steps < 0 ? targetElem.previousElementSibling : targetElem.nextElementSibling;
      }

      return targetElem;
    };

    let previousSecond = moveDateBySteps(datepicker1ActiveDate, -14);
    let previousThird = moveDateBySteps(datepicker2ActiveDate, -14);

    let nextSecond = moveDateBySteps(datepicker1ActiveDate, 14);
    let nextThird = moveDateBySteps(datepicker2ActiveDate, 14);

    if (previousSecond && (previousSecond.classList.contains('qs-range-start') || previousSecond.classList.contains('qs-range-middle'))) {
      previousSecond.classList.add('qs-active');
    }

    if (previousThird && (previousThird.classList.contains('qs-range-start') || previousThird.classList.contains('qs-range-middle'))) {
      previousThird.classList.add('qs-active');
    }

    if (nextSecond && (nextSecond.classList.contains('qs-range-start') || nextSecond.classList.contains('qs-range-middle'))) {
      nextSecond.classList.add('qs-active');
    }

    if (nextThird && (nextThird.classList.contains('qs-range-start') || nextThird.classList.contains('qs-range-middle'))) {
      nextThird.classList.add('qs-active');
    }

    datepicker1ActiveDate.classList.remove('qs-active');
    datepicker2ActiveDate.classList.remove('qs-active');

    if ( datepicker1.calendar.querySelector('.qs-active') && datepicker2.calendar.querySelector('.qs-active') ) {
      datepicker1.calendar.querySelector('.qs-active').classList.remove('qs-active');
    }
  };

  const addDays = (d, n) => {
    const x = new Date(d);
    x.setDate(x.getDate() + n);

    return x;
  };

  const daySuffix = (day) => {
    const lastTwoDigits = day % 100;
    const lastDigit = day % 10;

    let suffix = 'th';

    if (lastDigit === 1 && lastTwoDigits !== 11) {
      suffix = 'st';
    } else if (lastDigit === 2 && lastTwoDigits !== 12) {
      suffix = 'nd';
    } else if (lastDigit === 3 && lastTwoDigits !== 13) {
      suffix = 'rd';
    }

    return `<sup>${suffix}</sup>`;
  };

  const formatDate = (date) => {
    const month = date.toLocaleString('en-US', { month: 'long' });
    const day = date.getDate();
    const year = date.getFullYear();

    return `${month} ${day}, ${year}`;
  };

  const formatDateWithSuffix = (date) => {
    const month = date.toLocaleString('en-US', { month: 'long' });
    const day = date.getDate();
    const year = date.getFullYear();

    return `${month} ${day}${daySuffix(day)}, ${year}`;
  };

  const formatDateRangeWithSuffix = (startDate, endDate) => {
    const sameYear = startDate.getFullYear() === endDate.getFullYear();
    const sameMonth = sameYear && startDate.getMonth() === endDate.getMonth();

    const monthStart = startDate.toLocaleString('en-US', { month: 'long' });
    const monthEnd = endDate.toLocaleString('en-US', { month: 'long' });
    const dayStart = startDate.getDate();
    const dayEnd = endDate.getDate();
    const yearStart = startDate.getFullYear();
    const yearEnd = endDate.getFullYear();

    if (sameMonth) {
      return `${monthStart} ${dayStart}${daySuffix(dayStart)} and ${dayEnd}${daySuffix(dayEnd)}, ${yearStart}`;
    } else if (sameYear) {
      return `${monthStart} ${dayStart}${daySuffix(dayStart)} and ${monthEnd} ${dayEnd}${daySuffix(dayEnd)}, ${yearStart}`;
    } else {
      return `${monthStart} ${dayStart}${daySuffix(dayStart)}, ${yearStart} and ${monthEnd} ${dayEnd}${daySuffix(dayEnd)}, ${yearEnd}`;
    }
  };

  const retriggerSelect2 = ($select) => {
    if (!$select || !$select.length) return;

    const data = $select.select2('data');

    if (data && data.length) {
      $select
        .trigger('change')
        .trigger('select2:select', { data: data[0] });
    } else {
      $select.val(null).trigger('change');
      $select.trigger('select2:clear');
    }
  };

  const resetRadioButtons = () => {
    $('.js-inducer-radio-btn')
      .prop({ checked: false, defaultChecked: false })
      .removeAttr('checked')
      .trigger('change');
  };

  const resetCalendars = () => {
    lastInjectionDatePicker.setDate(null, true);
    nextInjectionMonth1DatePicker.setDate(null, true);
    nextInjectionMonth2DatePicker.setDate(null, true);
    inducerInitDatePicker.setDate(null, true);
    supplementalDoseDatePicker.setDate(null, true);
    nextSupplementalMonth1DatePicker.setDate(null, true);
    nextSupplementalMonth2DatePicker.setDate(null, true);

    $nextInjectionInfo
      .add($supplementalDoseInfo)
      .add($injectionResults)
      .add($inducerResults)
      .add('.js-dose-type-results')
      .add('.js-inducer-content')
      .add('.js-supplemental-dose-info')
      .add('.js-next-supplemental-dose-content')
      .add('.js-radio-buttons-wrap')
      .add('.js-inducer-before-injection-info')
      .add('.js-inducer-within-2d-after-injection')
      .add('.js-missing-injection-date-error')
      .addClass('is-hidden');

    $injectionLastDateElem.add($injectionLastDateDay2Elem).html('');
    $inducerSelect.val(null).trigger('change');
    $('.js-dose-type-radio-btn').prop('checked', false);
  };

  // GTM Tracking
  const pushEventToGTM = (eventName, params = {}) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      ...params
    });

    // console.log(window.dataLayer);
  };

  return {
    reset: resetCalendars,
  };
}


// WEBPACK FOOTER //
// ./src/assets/js/project/dosing-calc.js